// PORTED FROM apps/web — see apps/web-employer/PORTING.md (or web-admin/) for follow-ups

import * as React from "react";
import { useNavigate } from "react-router-dom"; // TODO: useRouter → useNavigate (nav(x) → nav(x), router.replace(x) → nav(x, {replace:true}))
import { useTranslations } from "next-intl";
import { Eye } from "lucide-react";
import type { WorkerKycSubmissionAdmin } from "@chotca/config";
import { useAdminWorkerKycList } from "@chotca/api-client";
import {
  DataTable,
  usePagination,
  type Column,
  type RowAction,
} from "@/components/data-table";

export function WorkersListClient() {
  const t = useTranslations("admin");
  const nav = useNavigate();
  const { page, pageSize, setPage, setPageSize } = usePagination();
  const { data, isLoading, isFetching } = useAdminWorkerKycList({
    page,
    limit: pageSize,
  });
  const items = (data?.items ?? []) as WorkerKycSubmissionAdmin[];

  const columns: Column<WorkerKycSubmissionAdmin>[] = [
    {
      key: "fullName",
      header: "Họ tên",
      cell: (s) => <span className="font-semibold text-ink">{s.fullName}</span>,
    },
    {
      key: "phone",
      header: "Phone",
      cell: (s) => <span className="text-xs">{s.userPhone ?? "—"}</span>,
    },
    {
      key: "email",
      header: "Email",
      cell: (s) => (
        <span className="text-xs text-ash">{s.userEmail ?? "—"}</span>
      ),
    },
    {
      key: "submittedAt",
      header: "Nộp lúc",
      cell: (s) => (
        <span className="whitespace-nowrap text-xs text-ash">
          {new Date(s.submittedAt).toLocaleString("vi-VN")}
        </span>
      ),
    },
  ];

  const rowActions: RowAction<WorkerKycSubmissionAdmin>[] = [
    {
      key: "view",
      label: "Xem chi tiết",
      icon: Eye,
      onClick: (s) => nav(`/kyc/workers/${s.id}`),
    },
  ];

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-ink">KYC – Worker</h1>
      </header>

      <DataTable
        columns={columns}
        data={items}
        isLoading={isLoading}
        isFetching={isFetching}
        rowKey={(s) => s.id}
        rowActions={rowActions}
        onRowClick={(s) => nav(`/kyc/workers/${s.id}`)}
        emptyText={t("todoSectionEmptyWorkerKyc")}
        page={page}
        pageSize={pageSize}
        total={data?.total}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
      />
    </div>
  );
}
